import { RawData } from './RawDataTypes';

const defaultState: RawData = {
  products: {},
};

export default defaultState;
